export default __webpack_public_path__ + "static/media/2020.8c881259.png";